import { render, staticRenderFns } from "./ShopWearParts.vue?vue&type=template&id=c76a944e&scoped=true"
import script from "./ShopWearParts.vue?vue&type=script&lang=js"
export * from "./ShopWearParts.vue?vue&type=script&lang=js"
import style0 from "./ShopWearParts.vue?vue&type=style&index=0&id=c76a944e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76a944e",
  null
  
)

export default component.exports